import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import MultiSelect from '../MultiSelect';
import { selectAllAgencies, useAgencies } from '../../../agencies/agenciesSlice';
import { useField } from 'formik';

const AgencyMultiselect = ({ name, label, autoSubmit, disabled }) => {
    const [{ value }, , { setValue }] = useField(name);
    const { loading } = useAgencies();
    const agencies = useSelector(selectAllAgencies);

    const options = useMemo(() => {
        if (!agencies) {
            return [];
        }
        const prepped = agencies.filter((agency) => agency.isActive).map(({ id, matchCode }) => ({
            label: matchCode,
            value: id,
        })).sort((a, b) => a.label.localeCompare(b.label));
        return [...prepped];
    }, [agencies]);

    useEffect(() => {
        // always make sure 'value' is an array.
        if (!Array.isArray(value)) {
            // This can happen if the initial value for this field in Formik is null or undefined.
            // We'll reset it to an empty array to maintain a consistent state.
            setValue([]);
        }
    }, [value, setValue]);

    return (
        <MultiSelect
            name={name}
            size="small"
            label={label}
            disabled={disabled || loading}
            options={options}
            autoSubmit={autoSubmit}
            fullWidth
        />
    );
};

AgencyMultiselect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    autoSubmit: PropTypes.bool,
    disabled: PropTypes.bool,
};

AgencyMultiselect.defaultProps = {
    label: null,
    autoSubmit: false,
    disabled: false,
};

export default AgencyMultiselect;
